import { useEffect, useState } from 'react';
import { formatDate, getCurrentDate } from './helpers';
const WORKING_HOURS_START = 10;
const WORKING_HOURS_END = 18;
const SUNDAY = 0;
const SATURDAY = 6;
const WEEKEND_DAYS = [SUNDAY, SATURDAY];
export const useBankWorkingTime = () => {
    const [isNotBankWorkingTime, setIsNotBankWorkingTime] = useState(false);
    useEffect(() => {
        const fetchPublicHolidaysOfGeorgia = async () => {
            const currentYear = getCurrentDate().get('year');
            const response = await fetch(`https://date.nager.at/api/v3/PublicHolidays/${currentYear}/GE`);
            const allHolydays = await response.json();
            const allHolydayDates = allHolydays.map((item) => item?.date);
            return allHolydayDates;
        };
        const checkWorkingTime = async () => {
            const holidays = await fetchPublicHolidaysOfGeorgia();
            const currentTime = getCurrentDate();
            const isWeekend = WEEKEND_DAYS.includes(currentTime.day());
            const currentDate = formatDate('YYYY-MM-DD', currentTime);
            const isHoliday = holidays.includes(currentDate);
            setIsNotBankWorkingTime(isHoliday ||
                currentTime.hour() >= WORKING_HOURS_END ||
                currentTime.hour() < WORKING_HOURS_START ||
                isWeekend);
        };
        checkWorkingTime();
    }, []);
    return isNotBankWorkingTime;
};
//# sourceMappingURL=useBankWorkingTime.js.map